import countriesData from "../countries.json";

/**
 * ISO 3166-1 alpha-2 codes of nationalities whose passport holders need a
 * Schengen visa to enter Germany (EU Council Regulation 2018/1806, Annex I).
 *
 * Nationalities not in this list are visa-free for short stays under Annex II
 * or by virtue of EU/EEA/Schengen membership, so they should not be shown in
 * the visa letter application form.
 */
export const VISA_REQUIRED_COUNTRY_CODES: ReadonlySet<string> = new Set([
  "AF", "DZ", "AO", "AM", "AZ", "BH", "BD", "BY", "BZ", "BJ",
  "BT", "BO", "BW", "BF", "BI", "KH", "CM", "CV", "CF", "TD",
  "CN", "KM", "CG", "CI", "CU", "CD", "DJ", "DO", "EC", "EG",
  "GQ", "ER", "SZ", "ET", "FJ", "GA", "GM", "GH", "GN", "GW",
  "GY", "HT", "IN", "ID", "IR", "IQ", "JM", "JO", "KZ", "KE",
  "KW", "KG", "LA", "LB", "LS", "LR", "LY", "MG", "MW", "MV",
  "ML", "MR", "MN", "MA", "MZ", "MM", "NA", "NR", "NP", "NE",
  "NG", "KP", "OM", "PK", "PS", "PG", "PH", "QA", "RU", "RW",
  "ST", "SA", "SN", "SL", "SO", "ZA", "SS", "LK", "SD", "SR",
  "SY", "TJ", "TZ", "TH", "TG", "TN", "TR", "TM", "UG", "UZ",
  "VN", "YE", "ZM", "ZW",
]);

export interface CountryOption {
  code: string;
  name: string;
}

export const visaRequiredCountries: CountryOption[] = (countriesData as CountryOption[])
  .filter((c) => VISA_REQUIRED_COUNTRY_CODES.has(c.code))
  .sort((a, b) => a.name.localeCompare(b.name));
